import { render, staticRenderFns } from "./PageBannerBig.vue?vue&type=template&id=3684c546&scoped=true&"
import script from "./PageBannerBig.vue?vue&type=script&lang=js&"
export * from "./PageBannerBig.vue?vue&type=script&lang=js&"
import style0 from "./PageBannerBig.vue?vue&type=style&index=0&id=3684c546&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684c546",
  null
  
)

export default component.exports